import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

const config = defineConfig({
  cssVarsRoot: ":where(:root, :host)",
  globalCss: {
    "*": {
      boxSizing: "border-box",
      fontFamily: '"Hiragino Kaku Gothic ProN", "Hiragino Sans", "Helvetica Neue", Arial, Meiryo, sans-serif',
    },
    "html, body": {
      margin: 0,
      padding: 0,
    },
  },
  theme: {
    tokens: {
      colors: {
        primary: { value: "#0D66AC" },
      },
    },
  },
});

export const customSystem = createSystem(defaultConfig, config);
